module.exports = __webpack_public_path__ + "img/quill_filled.8ae8a80a.svg";